module.exports = __webpack_public_path__ + "static/media/av_villas.cbb1eb66.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/new-order/payment-method/av_villas.png
// module id = 1994
// module chunks = 0